import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { LuMessageCircle } from 'react-icons/lu';

import { HeaderButton } from '../../HeaderButton';
import { ChatEntryDisabledTooltip } from '~/features/whatsapp/components/ChatEntryDisabledTooltip';
import { useChatEntryState } from '~/features/whatsapp/hooks/useChatEntryState';
import { useInboxUnreadSummary } from '~/features/whatsapp/hooks/useInboxUnreadSummary';
import { useIsCommunicationPage } from '~/features/whatsapp/hooks/useIsCommunicationPage';
import { openPanel } from '~/features/whatsapp/stores/chatPanelStore';
import { CHAT_ENTRY_STATES } from '~/features/whatsapp/utils/resolveChatEntryState';
import { unreadByChatIdFromSummary } from '~/features/whatsapp/utils/unreadByChatIdFromSummary';

// Badge is WS-driven (useInboxSocket invalidates this same query on `invalidate-unread`), not a
// poll interval like NotificationsMenu's own badge count.
export const ChatButton = () => {
    const { t } = useTranslation();
    const isCommunicationPage = useIsCommunicationPage();
    const { data } = useInboxUnreadSummary();
    const unreadByChatId = useMemo(() => unreadByChatIdFromSummary(data), [data]);
    const totalUnread = [...unreadByChatId.values()].reduce((sum, count) => sum + count, 0);
    const chatEntryState = useChatEntryState();
    const isDisabled = chatEntryState !== CHAT_ENTRY_STATES.ENABLED;

    if (chatEntryState === CHAT_ENTRY_STATES.HIDDEN || chatEntryState === CHAT_ENTRY_STATES.LOADING) return null;

    return (
        <ChatEntryDisabledTooltip state={chatEntryState}>
            <HeaderButton
                iconLeft={<LuMessageCircle />}
                disabled={isDisabled}
                onClick={() => {
                    if (isCommunicationPage) {
                        return;
                    }
                    openPanel();
                }}
            >
                <span className="text-midnight">{t('WHATSAPP_CHAT.HEADER_BUTTON.LABEL')}</span>
                {!isDisabled && totalUnread > 0 && (
                    <span className="ml-2 inline-flex size-6 shrink-0 items-center justify-center rounded-full bg-alert-error text-10 font-medium leading-none text-white tabular-nums">
                        {totalUnread > 99 ? '99+' : totalUnread}
                    </span>
                )}
            </HeaderButton>
        </ChatEntryDisabledTooltip>
    );
};
